import { Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import { CoreState, JurisdictionSelector } from "@obg/ngx.core";
import { ignoreNil } from "@obg/rxjs";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

import { LoginUiConfigService } from "../login.config";
import { NewLoginFlowStep } from "../login.model";

@Injectable({ providedIn: "root" })
export class NewFlowJurisdictionService {
	constructor(
		private store: Store<CoreState>,
		private loginUiConfigService: LoginUiConfigService
	) {}

	getFlowStepsConfigOnJurisdictionChange$(): Observable<NewLoginFlowStep[]> {
		return this.store.select(JurisdictionSelector.get).pipe(
			ignoreNil(),
			map(() => this.loginUiConfigService.getNewLoginFlowSteps())
		);
	}
}
